export class UserRegistration {
    public firstName: string;
    public lastName: string;
    public username: string;
    public email: string;
    public password: string;
    public repassword: string;
    public confirmationBaseUrl: string;
}
